import React from 'react'
import { Button, Element, Icon } from 'react-bulma-components'
import Modal, { useModal } from '../../modal'
import { UserRoleKind } from '../../../api/users'
import { UserAddIcon } from '@heroicons/react/outline'
import { UserForm } from '../forms/user-form'
import locales from '../../../../../locales'
import { useCreateMutationKey } from '../../../queries/users'
import { useMutationState } from '../../../queries'

interface InviteUserButtonProps {
  userRoleKind: UserRoleKind
  label?: string
  modalTitle?: string
}

const InviteUserButton: React.FC<InviteUserButtonProps> = ({ userRoleKind, label, modalTitle }) => {
  const createMutationStatus = useMutationState(useCreateMutationKey())
  const modal = useModal({
    autoClose: {
      on: Boolean(createMutationStatus?.status === 'success'),
      delay: 1500,
    },
  })
  const usersRoleLabel = locales.users.roles[userRoleKind]
  return (
    <>
      <Button
        onClick={() => modal.setIsDisplayed(true)}
        color="primary"
        data-test="invite-user"
        size="small"
      >
        <Icon>
          <UserAddIcon />
        </Icon>
        {label ? (
          <Element renderAs="span">{label}</Element>
        ) : (
          <Element renderAs="span">Inviter un {usersRoleLabel}</Element>
        )}
      </Button>
      <Modal
        title={modalTitle || `Inviter un nouvel utilisateur`}
        actions={modal}
        dataTest="worker-modal"
        maxWidth={1080}
      >
        <UserForm role={userRoleKind} />
      </Modal>
    </>
  )
}

export default InviteUserButton
